import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';
import { ProductInfo } from '../fragments';

export default gql`
  mutation createProduct($input: ProductCreateInput!) {
    createProduct(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      product {
        ...ProductInfo
      }
    }
  }
  ${ProductInfo}
  ${ErrorMessageInfo}
`;
